import type { Instance } from '@/services/miele-api-service';
import type { Customer } from '@/types/customer-types';
import type { ApiStatus } from '@/types/shared-types';
import { ref } from 'vue';

export type SignOutAction = (() => void) | null;

export default function useAccount() {
    const isAuthenticated = ref<boolean>(false);
    const hasLoggedOut = ref<boolean>(false);
    const customerData = ref<Customer | null>(null);
    const status = ref<ApiStatus>('IDLE');

    const clearCustomerData = () => {
        isAuthenticated.value = false;
        customerData.value = null;
    };

    const fetchCustomerData = async (service: Instance) => {
        status.value = 'RUNNING';

        return service
            .getUserData()
            .then((data) => {
                isAuthenticated.value = true;
                customerData.value = data;
                status.value = 'SUCCESS';
            })
            .catch((error) => {
                console.error('Unable to fetch user information', error);
                customerData.value = null;
                status.value = 'ERROR';
            });
    };

    const signOutAction = () => {
        clearCustomerData();
        hasLoggedOut.value = true;
    };

    return {
        status,
        isAuthenticated,
        fetchCustomerData,
        hasLoggedOut,
        customerData,
        signOutAction,
    };
}
